module.exports = __webpack_public_path__ + "img/2024-13.ff2ca52c.jpg";